export const htmlId: string = 'second-level-product-card';
